(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) {
document.addEventListener(
'DOMContentLoaded',
() => {
const card = document.getElementById(url.hash.slice(1));
if (card) {
card.scrollIntoView({ behavior: 'instant' });
}
},
{ once: true }
);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rkp-popular-manifest"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){var b=e.target.closest('[data-rkp-prev],[data-rkp-next]');if(!b)return;var g=b.closest('[data-rkp-gallery]'),s=[...g.querySelectorAll('[data-rkp-slide]')];if(s.length<2)return;var i=s.findIndex(x=>x.classList.contains('is-active')),d=b.hasAttribute('data-rkp-next')?1:-1,n=(i+d+s.length)%s.length;s.forEach((x,j)=>{x.classList.toggle('is-active',j===n);x.setAttribute('aria-hidden',j===n?'false':'true')})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rkp-video"] && !Shopify.designMode) return;
  try {
    
  class RkpVideoCover extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('.rkp-video__playbtn');
      const tpl = this.querySelector('template');
      if (!btn || !tpl) return;
      const play = () => {
        const player = tpl.content.cloneNode(true);
        this.replaceChildren(player);
        this.classList.add('is-playing');
        const video = this.querySelector('video');
        if (video && video.play) video.play().catch(() => {});
      };
      btn.addEventListener('click', play, { once: true });
    }
  }

  if (!customElements.get('rkp-video-cover')) {
    customElements.define('rkp-video-cover', RkpVideoCover);
  }

  } catch(e) { console.error(e); }
})();
})();
